<template>
  <el-dialog :close-on-click-modal="false" widht="" :show-close="true"
             :visible.sync="downloadVisible" custom-class="translationDownloadDialog"
             :before-close="handlerClose">
    <template slot="title">
      <DialogsHeader :title="$t('common.download')" />
    </template>
    <div class="content">
      <div class="source item" @click="handlerDownload(6)">
        {{$t('project.originalText')}}
      </div>
      <div class="target item" @click="handlerDownload(1)">
        {{$t('project.translatedText')}}
      </div>
      <el-tooltip effect="dark" :disabled="tipsDisabled"
                  :content="$t('project.originalAndTranslatedText')" placement="top-start">
        <div class="translation item" @click="handlerDownload(2)"
             @mouseover="mouseOverShowTips($event)">
          {{$t('project.originalAndTranslatedText')}}
        </div>
      </el-tooltip>
      <!-- <div v-show="isDownloadLoading" id="downloadLoadingBox">
        <div class="loadingMain">
          <i class="el-icon-loading"></i>
          <p>{{$t('projectDetailsV2.downloading')}}</p>
        </div>
      </div> -->
    </div>
    <div slot="footer">
      {{$t('warehousingAudit.clickIconDownload')}}
    </div>
  </el-dialog>
</template>
<script>
import DialogsHeader from '@/common/dialogsHeader';
import { apiRoot } from '@/services/ajax';
import { getDownloadAsyncResult, exportAsyncTransFile } from '@/services/projectDetailsApi';
export default {
  name: 'translationDownloadDialog',
  data() {
    return {
      downloadFileName: "",
      tipsDisabled: true,
      isDownloadLoading: false
    }
  },
  props: {
    downloadVisible: {
      type: Boolean,
    },
    idList: {
      type: Array,
      default: () => []
    },
    downloadType: {
      type: String,
      default: ""
    },
    downloadId: {
      type: Number,
      default: 0
    }
  },
  components: { DialogsHeader },
  methods: {
    handlerClose() {
      this.$emit('handlerClose');
    },
    mouseOverShowTips(e) {
      let clientWidth = e.target.clientWidth
      let scrollWidth = e.target.scrollWidth
      this.tipsDisabled = scrollWidth > clientWidth ? false : true
    },
    async handlerDownload(type) {
      this.$emit('handlerdownLoading', 'open')
      if (this.downloadType === 'batchdownload') {
        switch (type) {
          case 6:
            this.downloadFileName = `（${this.$t('project.originalText')}）.zip`;
            break;
          case 1:
            this.downloadFileName = `（${this.$t('projectDetailsV2.transVersion')}）.zip`;
            break;
          case 2:
            this.downloadFileName = `（${this.$t('intelligentTranslation.Translation')}）.zip`;
            break;
          default: 6
            break;
        }
        await this.asynchronizationDownload(`/api/v1/file/exportAsyncFile?type=${type}&fileList=${this.idList}&projectId=1`);
        this.$emit('handlerdownLoading', 'close')
      } else {
        let param = {
          type,
          fileId: this.downloadId
        };
        let { resultCode, result } = await exportAsyncTransFile(param);
        if (resultCode !== "1") {
          this.$emit('handlerdownLoading', 'close')
          return;
        }
        if (result.percent == 100) {
          this.downloadServerFile(result.fileName, result.downloadUrl)
        } else {
          this.isDownloadLoading = true;
          this.getDownloadAsyncResult(result.taskKey);
        }
      }
    },
    async asynchronizationDownload(url) {
      const response = await this.catReq1Service(url, {}, 'get')
      if (response.resultCode === "1") {
        const result = response.result;
        if (result.percent == 100) {
          this.downloadServerFile(result.fileName, result.downloadUrl);
        } else {
          this.isDownloadLoading = true;
          this.getDownloadAsyncResult(result.taskKey)
        }
      }
    },
    // a链接下载
    downloadServerFile(fileName, filePath) {
      let link = document.createElement("a");
      link.style.display = "none";
      if (this.downloadFileName !== '') {
        fileName = this.downloadFileName;
      }
      link.href = apiRoot(`/file/downloadServerFile?fileName=${fileName}&filePath=${filePath}`);
      link.setAttribute("download", fileName);
      this.downloadFileName = '';
      document.body.appendChild(link);
      link.click();
      this.$emit('handlerdownLoading', 'close')
    },
    // 轮询下载
    async getDownloadAsyncResult(taskKey) {
      let setItem = setInterval(async () => {
        let { resultCode, result } = await getDownloadAsyncResult({ taskKey });
        if (resultCode === "1") {
          if (parseInt(result.percent) === 100) {
            clearInterval(setItem);
            setItem = null;
            this.isDownloadLoading = false;
            // this.$emit('handlerdownLoading', 'close')
            this.downloadServerFile(result.fileName, result.downloadUrl)
          }
        } else {
          clearInterval(setItem);
          setItem = null;
          this.isDownloadLoading = false;
        }
        this.$emit('handlerdownLoading', 'close')
      }, 2000);
    },
  }
}
</script>

<style lang="less" scoped>
/deep/.translationDownloadDialog {
  width: 628px;
  height: 272px;
  border-radius: 4px 4px 4px 4px;
  box-shadow: 0px 10px 28px 1px rgba(51, 51, 51, 0.18);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
  .el-dialog__header {
    margin: 0 60px;
    padding-bottom: 0px !important;
  }
  .el-dialog__body {
    margin: 32px 0 32px 0;
    padding: 0 20px;
    .content {
      display: flex;
      justify-content: center;
      .item {
        width: 80px;
        height: 86px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #ebeef5;
        line-height: 126px;
        font-size: 14px;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;

        &:hover {
          color: #0078fc;
          border-color: #0078fc;
        }
      }
      .source {
        background: url("../images/source-download.png") no-repeat;
        background-position: center 19px;
        &:hover {
          background: url("../images/source-download-pre.png") no-repeat;
          background-position: center 19px;
        }
      }
      .target {
        margin: 0 51px;
        background: url("../images/target-download.png") no-repeat;
        background-position: center 19px;
        &:hover {
          background: url("../images/target-download-pre.png") no-repeat;
          background-position: center 19px;
        }
      }
      .translation {
        background: url("../images/originalTarslation.png") no-repeat;
        background-position: center 19px;
        &:hover {
          background: url("../images/originalTarslation-pre.png") no-repeat;
          background-position: center 19px;
        }
      }
    }
  }
  .el-dialog__footer {
    border-top: 2px solid rgba(51, 51, 51, 0.18);
    margin: 0px 60px;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    padding: 0px;
    line-height: 38px;
    color: #909399;
  }
}
</style>